module.exports = __webpack_public_path__ + "img/ywbk03.5ff5be32.jpg";